function setupCampaignHero(root) {
  const triggerButton = root.querySelector('[data-campaign-hero-klaviyo-trigger]');
  const overlay = root.querySelector('[data-campaign-hero-klaviyo-overlay]');

  if (!triggerButton || !overlay) return;

  const closeElements = overlay.querySelectorAll('[data-campaign-hero-klaviyo-close]');

  function openModal() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    setTimeout(() => {
      overlay.classList.add('is--open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('campaign-hero-modal-open');
    }, 300);
  }

  function closeModal() {
    overlay.classList.remove('is--open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('campaign-hero-modal-open');
  }

  triggerButton.addEventListener('click', openModal);
  closeElements.forEach((element) => element.addEventListener('click', closeModal));

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overlay.classList.contains('is--open')) {
      closeModal();
    }
  });
}

function initCampaignHeroSections() {
  document.querySelectorAll('.campaign-hero').forEach((root) => {
    if (root.dataset.campaignHeroBound === 'true') return;
    root.dataset.campaignHeroBound = 'true';
    setupCampaignHero(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCampaignHeroSections);
} else {
  initCampaignHeroSections();
}

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initCampaignHeroSections);
}